<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="敏感词" text="敏感词屏蔽列表">
          <v-layout row wrap class="mx-3">
            <v-layout row wrap xs12>
              <v-flex sm3>
                <v-text-field
                  hide-details
                  label="敏感词"
                  v-model="searchKeyword"
                  v-on:keyup.enter="onClickSearch"
                ></v-text-field>
              </v-flex>
              <v-flex sm3 class="text-no-wrap">
                <v-btn color="orange" dark class="mx-2" @click="onClickReset">重置</v-btn>
                <v-btn color="green" dark @click="onClickSearch">查询</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :pagination.sync="pagination"
                :rows-per-page-items="rowsPerPageItems"
                :disable-initial-sort="true"
              >
                <template slot="headerCell" slot-scope="{ header }">
                  <span
                    class="subheading font-weight text-success text--darken-3"
                    v-text="header.text"
                  />
                </template>
                <template slot="items" slot-scope="{ item }">
                  <td>{{ item.id }}</td>
                  <td>{{ item.keyword }}</td>
                  <td>{{ formateDate(item.createdAt) }}</td>
                  <td class="text-no-wrap">
                    <v-chip
                      small
                      color="red"
                      text-color="white"
                      class="pointer"
                      @click="onClickDelete(item)"
                    >删除</v-chip>
                  </td>
                </template>
                <!-- <template slot="footer">
                  <tr>
                    <td colspan="4">
                    </td>
                  </tr>
                </template> -->
              </v-data-table>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>

      <v-layout row xs12 wrap mx-3>
        <v-flex sm3>
          <v-text-field
            hide-details
            label="新增敏感词"
            v-model="newKeyword"
            v-on:keyup.enter="onClickAdd"
          ></v-text-field>
        </v-flex>
        <v-flex sm3 class="text-no-wrap">
          <v-btn fab small color="green" dark @click="onClickAdd">添加</v-btn>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import global from '@/global'
import dayjs from 'dayjs'
import { getKeywordsByPage, deleteKeyword, addKeyword } from '@/services'

export default {
  data: () => ({
    headers: [
      {
        text: 'ID',
        value: 'id'
      },
      {
        text: '敏感词',
        value: 'keyword'
      },
      {
        text: '创建时间',
        value: 'createdAt'
      },
      {
        text: '操作',
        sortable: false
      }
    ],
    items: [],
    rowsPerPageItems: [2, 5, 10, 20, 50],
    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: false,
      sortBy: null
    },
    criteria: [],
    searchKeyword: null,
    newKeyword: ''
  }),

  computed: {
    tempParams() {
      return {
        descending: this.pagination.descending || null,
        page: this.pagination.page || null,
        rowsPerPage: this.pagination.rowsPerPage || null,
        sortBy: this.pagination.sortBy || null
      }
    },

    totalItems() {
      return (this.pagination && this.pagination.totalItems) || 0
    }
  },

  watch: {
    tempParams: {
      async handler(oldValue, newValue) {
        // console.log('oldValue', JSON.stringify(oldValue))
        if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
          return
        }
        // console.log('newValue', JSON.stringify(newValue))
        await this.fetchData()
      }
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      let pagination = await getKeywordsByPage({
        ...this.pagination,
        criteria: this.criteria
      })

      if (pagination) {
        // remove items from pagination
        this.pagination = { ...pagination, items: [] }
        this.items = pagination.items
      }
    },

    formateDate(x) {
      return dayjs(x).format('YYYY-MM-DD HH:mm')
    },

    async onClickSearch() {
      let criteria = []
      if (this.searchKeyword) {
        criteria.push({
          name: 'keyword',
          op: 'like',
          value: `%${this.searchKeyword}%`
        })
      }

      this.criteria = criteria
      await this.fetchData()
    },

    async onClickReset() {
      this.criteria = []
      this.searchKeyword = null
      await this.fetchData()
    },

    async onClickDelete(item) {
      let res = await deleteKeyword(item.id)
      if (res) {
        await this.fetchData()
        global.showSuccess('已删除')
      }
    },

    async onClickAdd() {
      if (this.newKeyword && this.newKeyword.trim()) {
        let res = await addKeyword(this.newKeyword)
        if (res) {
          await this.fetchData()
          global.showSuccess('添加成功')
        }
      }
    }
  }
}
</script>
